module.exports = __webpack_public_path__ + "static/img/illu_en_03.a31938d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_en_03.png
// module id = xDxn
// module chunks = 1